import React, { useEffect, useRef } from "react";
import Image from "next/image";
import { BANNER_SWIPER_COMPANY_ITEMS } from "@/lib/utils";
import CounterComponent from "@/components/common/CounterComponent";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import EnqueryForm from "@/components/forms/EnqueryForm";

const UspBannerDesktop = () => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      stopOnFocusIn: false,
    }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      skipSnaps: false,
      breakpoints: {
        "(min-width: 768px)": { slidesToScroll: 1 },
        "(min-width: 1024px)": { slidesToScroll: 1 },
      },
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);
  return (
    <>
      <div className="md:block hidden mx-auto w-full 2xl:h-[630px] md:h-[630px] h-[95vh] xl:px-0 md:px-6 lg:!px-6 px-5 relative square_grid_bg bg-repeat bg-cover bg-[length:100% 100%] md:pb-0 pb-[0px] overflow-hidden">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative h-full">
          <div className="flex justify-between items-center relative md:top-[65px] mx-auto">
            <div className="md:relative w-full md:mt-5 mt-7">
              <Image
                src="/accounting/usp_sticker.png"
                alt="Special Offer"
                className="block w-[60%] md:ml-[-2px]"
                width={471}
                height={155}
                priority
              />
              <p className="2xl:text-[22px] md:text-[20px] text-[20px] font-medium  leading-normal tracking-[-0.6px] text-[#202852] mt-4">
                Miles has cracked the puzzle for Global Accountants!
              </p>
              <p className="text-[#202852] 2xl:text-[30px] md:text-[26px] font-semibold mt-2 mb-2 leading-normal tracking-[-0.8px]">
                Accountants worldwide can now
              </p>
              <h1 className="2xl:text-[64px] md:text-[64px] text-[34px] font-bold leading-normal tracking-[-4px] text-[#061A2F] md:text-[#061A2F] mt-[-25px]">
                Work in the US
              </h1>
              <p className="text-[#0C1F33] font-[Work Sans] font-semibold lg:text-[24px] md:text-[24px] text-[24px] md:mt-0 mt-[-7px] leading-[44px]">
                Starting salary{" "}
                <span className="bg-[#FFBA08] font-bold text-black w-[300px] mt-[-4px] leading-[116%] tracking-[-1.2px] lg:text-[28px] md:text-[30px] text-[30px] md:px-1">
                  $60,000+
                </span>
              </p>
              <p className="italic font-semibold text-[#272727] md:text-[16px] md:mt-[30px] leading-normal tracking-[-0.96px]">
                Our alumni work at
              </p>
              <div className="md:w-full md:mt-5">
                <div
                  className=" w-full pb-4 embla overflow-hidden"
                  ref={emblaRef}
                >
                  <div className="embla__container flex h-full">
                    {BANNER_SWIPER_COMPANY_ITEMS?.map((item) => (
                      <div
                        className="embla__slide h-full flex-[0_0_70%] min-w-0 sm:flex-[0_0_50%] md:flex-[0_0_33%] lg:flex-[0_0_23.67%] pr-7"
                        key={item?.companyImageURL}
                      >
                        <Image
                          priority
                          src={item?.companyImageURL}
                          alt={item?.companyImageURL}
                          className=" mx-auto"
                          width={item?.companyImageWidth}
                          height={item?.companyImageheight}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full relative flex items-center justify-center lg:justify-end z-[1] bottom-1 lg:pt-12">
              <div className="w-[400px] p-4 border border-white rounded-2xl bg-gradient-to-b from-white/30 to-blue-400/30 shadow-[0px_0px_14px_0px_rgba(4,84,175,0.29)] backdrop-blur-[28px] relative">
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                  alt="star group"
                  width={34}
                  height={38}
                  className="absolute top-1 left-0"
                  loading="lazy"
                />

                <EnqueryForm
                  course="USP"
                  courseId={3}
                  formHeading={FormHeading.WEEKLY_LIVE_WEBINAR_WITH_VARUN_JAIN}
                  formType="page"
                  isAStepperForm
                  subCategory={FinanceAndAccountingSubcategory.USP}
                  submitButtonName="Request a call back"
                  successMessage={SuccessMessageType.ACCOUNTING}
                  verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
                  darkBackground={false}
                />
              </div>
            </div>
          </div>
          <div className="lg_desktop">
            <Image
              src="/accounting/desktop_banner.png"
              alt="Special Offer"
              className="absolute top-0 bottom-0 right-0 z-0 h-full"
              width={720}
              height={570}
              priority
            />
          </div>
        </div>
        <div className="md_desktop">
          <Image
            src="/accounting/desktop_banner.png"
            alt="Special Offer"
            className="absolute top-0 bottom-0 right-0 md:block hidden  z-10 md:w-[700px] md:h-[700px]"
            width={1102}
            height={962}
            priority
          />
        </div>
      </div>

      <div className="md:block hidden bg-[#061A2F] w-full 2xl:py-9 md:py-7 py-6 z-10 shadow_blue">
        <div className="lg:container mx-auto">
          <div className="flex md:justify-between md:flex-nowrap flex-wrap md:px-14">
            <CounterComponent
              endValue={70000}
              suffix="+"
              title="Global Alumni"
              duration={3000}
              containerClassName="md:w-[30%] w-[100%] md:mt-0 mt-5"
              numberClassName="2xl:text-[64px] md:text-[42px] text-3xl font-medium text-white leading-normal tracking-[-2.56px]"
              titleClassName="2xl:text-[32px] md:text-[24px] text-xl font-medium text-[#DCDCDC] leading-normal tracking-[-1.28px]"
            />
            <CounterComponent
              endValue={600}
              suffix="+"
              title="Employers"
              duration={2000}
              containerClassName="md:w-[30%] w-[100%] md:mt-0 mt-5"
              numberClassName="2xl:text-[64px] md:text-[42px] text-3xl font-medium text-white leading-normal tracking-[-2.56px]"
              titleClassName="2xl:text-[32px] md:text-[24px] text-xl font-medium text-[#DCDCDC] leading-normal tracking-[-1.28px]"
            />
            <CounterComponent
              endValue={1500}
              suffix="+"
              title="Universities"
              duration={1500}
              containerClassName="md:w-[30%] w-[100%] md:mt-0 mt-5"
              numberClassName="2xl:text-[64px] md:text-[42px] text-3xl font-medium text-white leading-normal tracking-[-2.56px]"
              titleClassName="2xl:text-[32px] md:text-[24px] text-xl font-medium text-[#DCDCDC] leading-normal tracking-[-1.28px]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UspBannerDesktop;
